var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cwx-vuetify-styles-wrapper"},[_c('v-app',[_c('ItemListTiles',_vm._b({},'ItemListTiles',_vm.listData,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }